//Константы из SetupView
export default {
  header_title: "Активы",
  header_description: "Выберите актив",
  loading: "Загрузка приложения...",
  preview: "Просмотр",
  error: "Произошла ошибка",
  view_not_configured: "Представление не настроено"
}
